/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_MockInputs */

const en_svtag_mock = /** @type {(inputs: Svtag_MockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOCK`)
};

const ar_svtag_mock = /** @type {(inputs: Svtag_MockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#نماذج`)
};

const bn_svtag_mock = /** @type {(inputs: Svtag_MockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOCK`)
};

const de_svtag_mock = /** @type {(inputs: Svtag_MockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOCK`)
};

const es_svtag_mock = /** @type {(inputs: Svtag_MockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOCK`)
};

const fr_svtag_mock = /** @type {(inputs: Svtag_MockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOCK`)
};

const pt_svtag_mock = /** @type {(inputs: Svtag_MockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOCK`)
};

const zh_svtag_mock = /** @type {(inputs: Svtag_MockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOCK`)
};

const tr_svtag_mock = /** @type {(inputs: Svtag_MockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOCK`)
};

const ru_svtag_mock = /** @type {(inputs: Svtag_MockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOCK`)
};

const pl_svtag_mock = /** @type {(inputs: Svtag_MockInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MOCK`)
};

/**
* | output |
* | --- |
* | "#MOCK" |
*
* @param {Svtag_MockInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_mock = /** @type {((inputs?: Svtag_MockInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_MockInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_mock(inputs)
	if (locale === "bn") return bn_svtag_mock(inputs)
	if (locale === "de") return de_svtag_mock(inputs)
	if (locale === "es") return es_svtag_mock(inputs)
	if (locale === "fr") return fr_svtag_mock(inputs)
	if (locale === "pt") return pt_svtag_mock(inputs)
	if (locale === "zh") return zh_svtag_mock(inputs)
	if (locale === "tr") return tr_svtag_mock(inputs)
	if (locale === "ru") return ru_svtag_mock(inputs)
	if (locale === "pl") return pl_svtag_mock(inputs)
	return en_svtag_mock(inputs)
});